import { SnowplowService } from "~/services/public/Snowplow"
import { getv4LocaleFromI18nLocale } from "~/scripts/useful-functions"
import { newTracker } from "@snowplow/browser-tracker"

export default defineNuxtPlugin(nuxtApp => {
  if (import.meta.client) {
    newTracker("cms-content-tracker", nuxtApp.$config.public.snowplowHost, {
      appId: "cms-content",
      platform: "web"
    })
    const snowplowService = new SnowplowService()
    const locale = getv4LocaleFromI18nLocale(nuxtApp.$i18n.locale.value)
    snowplowService.addLocaleContext(locale)

    return {
      provide: {
        snowplow: snowplowService
      }
    }
  }
})
